// TES-1093: Rollen-Weiche für das '/'-Dashboard (Owner-abgenommene Matrix, 2026-06-11).
// TES-2101 (Owner-Entscheid 2026-07-06): qm_admin ist NICHT operativ und bekommt KEIN Dashboard —
// Landing ist die „braucht Aktion"-Arbeitsliste (/tasks), analog zum admin-Redirect-Muster.
//
// | Rolle               | Variante                                              |
// | ------------------- | ----------------------------------------------------- |
// | super_admin (global)| administrative Übersicht (TES-1092, SuperAdminDashboard) |
// | super_admin (Guest) | Redirect /admin/users (TES-1092, unverändert)         |
// | admin               | KEIN operatives Dashboard → Redirect /admin/users     |
// | qm_admin            | KEIN operatives Dashboard → Redirect /tasks (TES-2101) |
// | qualitaetsmanager   | Bereichs-/Teamsicht (bestehendes volles Dashboard)    |
// | tester              | „Mein Tag"-Preview (Inspector-Dashboard-Muster)       |
// | mangelbearbeiter    | Mängel-Inbox                                          |
// | customer_approver / sonst | generisches Dashboard                  |
//
// Prioritäten bei Mehrfachrollen: super_admin > admin > qm_admin > qualitaetsmanager >
// tester > mangelbearbeiter. Das spiegelt die bestehende Dashboard-Logik
// (`showInspections`/`canSeeAll`) wider: die übergeordnete Sicht gewinnt.

export type DashboardVariant =
  | "super-admin"
  | "admin-redirect"
  | "qm-admin-redirect"
  | "qualitaetsmanager"
  | "tester"
  | "mangelbearbeiter"
  | "generic";

export interface DashboardRoleFlags {
  isSuperAdmin: boolean;
  isAdmin: boolean;
  /** role_id-only Org-Hülle (v2.3, TES-1973) — nicht operativ, kein app_role-Enum. */
  isQmAdmin: boolean;
  isQualitaetsmanager: boolean;
  isTester: boolean;
  isMangelbearbeiter: boolean;
  /** true, wenn der super_admin im Tenant-Guest-Mode unterwegs ist (profile.active_tenant_id gesetzt). */
  hasActiveTenant: boolean;
}

interface VariantRule {
  matches: (flags: DashboardRoleFlags) => boolean;
  variant: DashboardVariant;
}

// Reihenfolge = Priorität. TES-1092: Guest-Mode-super_admin (active_tenant_id
// gesetzt) → unverändert zur Benutzerverwaltung; global → administrative Übersicht.
const VARIANT_RULES: VariantRule[] = [
  { matches: (f) => f.isSuperAdmin && f.hasActiveTenant, variant: "admin-redirect" },
  { matches: (f) => f.isSuperAdmin, variant: "super-admin" },
  { matches: (f) => f.isAdmin, variant: "admin-redirect" },
  { matches: (f) => f.isQmAdmin, variant: "qm-admin-redirect" },
  { matches: (f) => f.isQualitaetsmanager, variant: "qualitaetsmanager" },
  { matches: (f) => f.isTester, variant: "tester" },
  { matches: (f) => f.isMangelbearbeiter, variant: "mangelbearbeiter" },
];

export function resolveDashboardVariant(flags: DashboardRoleFlags): DashboardVariant {
  const rule = VARIANT_RULES.find((candidate) => candidate.matches(flags));
  return rule ? rule.variant : "generic";
}
